module.exports = __webpack_public_path__ + "static/fonts/Roboto-Medium.90d1676.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/sales/dashboard2/assest/font/roboto/Roboto-Medium.woff2
// module id = bwsE
// module chunks = 0